import Vue from "vue";
import BzbsApi from "@/core/Http/BzbsApi.js";
import ConfigManager from "@/config/ConfigManager.js";

/**
 * @method apiGetCustom
 */

export default {
    config: function() {
        return Vue.bzbsConfig;
    },
    timestamp: function() {
        const timestamp = Date.now();
        return timestamp;
    },
    /**
     * Return Custom object.
     * @param {String} path
     */
    apiGetCustom: function(path) {
        const url = `${ConfigManager.getBlobUrl()}${path}?v=${this.timestamp()}`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    // console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
};
